import {Component} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MdIconRegistry} from '@angular/material';
/**
 * \@title SVG icons
 */
export class IconSvgExample {
/**
 * @param {?} iconRegistry
 * @param {?} sanitizer
 */
constructor(iconRegistry: MdIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
        'thumbs-up',
        sanitizer.bypassSecurityTrustResourceUrl('assets/img/examples/thumbup-icon.svg'));
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'icon-svg-example',
  templateUrl: 'icon-svg-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdIconRegistry, },
{type: DomSanitizer, },
];
}

function IconSvgExample_tsickle_Closure_declarations() {
/** @type {?} */
IconSvgExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
IconSvgExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
